import { get } from "lodash-es";

export const usersParser = (response, dispatch) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return [];
        }
        if (response.results)
            response.results = response.results.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    name: get(row, "name", ""),
                    email: get(row, "email", ""),
                    mobile: get(row, "mobile", ""),
                    role: get(row, "role", ""),
                    is_active: get(row, "is_active", false),
                    is_b2b: get(row, "is_b2b", false),
                    dob: get(row, "dob", false),
                    full_address: get(row, "full_address", false),
                    aadhar_number: get(row, "aadhar_number", false),
                    region_id: get(row?.region, "id", null),
                    parent_id: get(row, "parent_id", ""),
                    created_at: get(row, "created_at", ""),
                };
            });

        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const usersParserDropdown = (response, dispatch) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return [];
        }
        if (response.results)
            response.results = response.results.map((row, key) => {
                return {
                    id: get(row, "id", ""),
                    name: get(row, "name", ""),
                    role: get(row, "role", ""),
                };
            });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};

export const usersParserHierarchy = (response, dispatch) => {
    try {
        if (response?.result) {
            response = response.result;
        }
        if (!response) {
            return { hierarchy: [], totalUsers: 0 };
        }
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
